/* global wp */
import { get } from 'lodash'
import classNames from 'classnames'
import Notice from './elements/notice'
import LogoImage from './sync/logo-image'
import WpLogoImage from './sync/wp-logo-image'
import HubLogoImage from './sync/hub-logo-image'

const { __ } = wp.i18n
const {
	useEffect,
	useCallback,
	useState
} = wp.element

const Syncing = () => {
	// Set initial variables.
	const [start, setStart] = useState(true)
	const [error, setError] = useState('')
	const [synced, setSynced] = useState(false)

	const {
		sync_error,
		sync_desc1,
		sync_desc2,
		sync_loading
	} = get(window, 'hubConnectorVars.texts', false)

	/**
	 * Attempt to sync the site with Hub.
	 *
	 * @since 1.0.0
	 */
	const doHubSync = useCallback(async () => {
		const apiUrl = get(window, 'hubConnectorVars.api_url', '')
		const currentUrl = get(window, 'hubConnectorVars.login.current_url', '')

		// Sync the site.
		await fetch(apiUrl + 'sync', {
			method: 'POST',
			body: JSON.stringify({ force: true }),
			headers: {
				'Content-Type': 'application/json',
				'X-WP-Nonce': get(window, 'hubConnectorVars.nonce', ''),
			}
		})
		.then(async (response) => {
			let responseData = await response.json();

			if (response.ok) {
				if (responseData.success) {
					// Reload page.
					window.location = currentUrl;
				} else if (responseData.error) {
					// Not success.
					setError(responseData.error)
				}
			} else {
				// Not success.
				setError(sync_error)
			}
		})
		.catch(() => {
			// Unknown error.
			setError(sync_error)
		})
		.finally(() => {
			setSynced(true)
		})
	})

	useEffect(() => {
		// Make animation.
		const timer = setInterval(() => {
			setStart(!start)
		}, 5000)

		// Do hub sync.
		if (!synced) {
			doHubSync()
		}

		// Make sure to clear animation.
		return () => clearTimeout(timer)
	}, [])

	return (
		<main className="sui-wrap">
			<div className="dashui-onboarding">
				<div className="dashui-onboarding-body dashui-onboarding-content-center">
					<div className="dashui-login-form animate-sync">
						<LogoImage/>
						<h2>{__('Connecting...', 'wpmudev')}</h2>
						<span className="sui-description">
								{sync_loading}
							</span>
						{error ?
							<Notice style={{ marginTop: '10px' }}>
								<p dangerouslySetInnerHTML={{__html: error}}></p>
							</Notice>
							:
							<div className="dashui-connect">
								<div className="dashui-connect-header" aria-hidden="true">
									<div className="dashui-connect-image">
										<HubLogoImage start={start}/>
									</div>
									<div className="dashui-connect-loading-bar"></div>
									<div className="dashui-connect-image">
										<WpLogoImage start={start}/>
									</div>
								</div>
								<div className={classNames({
									'dashui-connect-body': true,
									'dashui-final-stage': !start
								})}>
									<p className="dashui-stage-text">
										{start ? sync_desc1 : sync_desc2}
									</p>
								</div>
								<div className="dashui-connect-navigation" aria-hidden="true">
									<span className={classNames({ 'dashui-current': start })}></span>
									<span className={classNames({ 'dashui-current': !start })}></span>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</main>
	)
}

export default Syncing
